import { asyncScheduler, ObservableInput, scheduled } from 'rxjs';

export function scheduledAsync<T>(input: ObservableInput<T>) {
  return scheduled(input, asyncScheduler);
}
